import React, { useContext } from 'react'
import { Button, Card, Icon, Label, Image, Popup } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { AuthContext } from '../context/auth'

import LikeButton from "./LikeButton"
import DeleteButton from "./DeleteButton"

export default function PostCard(post) {
    const { body, createdAt, id, username, likeCount, commentCount, likes, image } = post["post"]
    const { user } = useContext(AuthContext);
    return (
        <Card fluid>
            <Card.Content>
                <Image
                    floated='right'
                    size='mini'
                    src='https://picsum.photos/200'
                />
                <Card.Header>{username}</Card.Header>

                <Card.Meta as={Link} to={`/posts/${id}`}>{moment(createdAt).fromNow(true)}</Card.Meta>
                {image &&
                    <Card.Description>
                        <Image src={image} className="image"></Image>
                    </Card.Description>
                }
                <Card.Description>
                    {body}
                </Card.Description>
            </Card.Content>
            <Card.Content extra>
                <LikeButton user={user} post={{ id, likes, likeCount }} />
                <Popup content='Comment on post' inverted trigger={

                    <Button labelPosition='right' as={Link} to={`/posts/${id}`}>
                        <Button color='blue' basic>
                            <Icon name='comments' />
                        </Button>
                        <Label basic color='blue' pointing='left'>
                            {commentCount}
                        </Label>
                    </Button>

                } />
                {user && user.username === username && <DeleteButton postId={id} />}
            </Card.Content>
        </Card >
    )
}